import { CountEvent, CountLogDTO } from "../tsClasses/CHTypes";
import { apiPath } from "./GeneralFunc";

type AddItemsToCountEventProps = {
  countEvenIdToAdd: number;
  countItemsList: string[];
  userToken: string;
};

const AddItemsToCountEvent = async (props: AddItemsToCountEventProps) => {

  const dataToSend = {
    countEventId: props.countEvenIdToAdd,
    itemsSku: props.countItemsList,
  };

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", token: props.userToken },
    body: JSON.stringify(dataToSend),
  };
  try {
    const response = await fetch(
      apiPath + "/addItemsToCountEvent",
      requestOptions
    );
    if (response.status == 401) {
      return "Unauthorized";
    }
    if (response == null) {
    }

    const result = await response.text();
    return result;
  } catch (error) {
    return "gotErr";
  }
};

export default AddItemsToCountEvent;
